import React, { useMemo } from "react";

import { AutoFormFieldProps } from "@autoform/react";

import { DateTimePicker } from "@/components/fields/date-time-picker";

export const DateTimeField: React.FC<AutoFormFieldProps> = ({
  id,
  field,
  inputProps,
  value,
}) => {
  const { key, ...rest } = inputProps;
  const dateTimeValue = useMemo(() => {
    return value instanceof Date ? value : value ? new Date(value) : undefined;
  }, [value]);

  return (
    <div className="flex flex-col text-foreground">
      <DateTimePicker
        {...rest}
        defaultValue={dateTimeValue}
        clearable={
          (field.fieldConfig?.customData as { clearable?: boolean } | undefined)
            ?.clearable === true
        }
        onChange={(value) => {
          const syntheticEvent = {
            target: {
              value: value?.toISOString(),
              name: id,
            },
          } as unknown as React.ChangeEvent<HTMLInputElement>;
          inputProps.onChange(syntheticEvent);
        }}
      />
    </div>
  );
};
